import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApiService } from '@augusoft/asf-core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'asf-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.less']
})
export class LoginFormComponent implements OnInit {
  username = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [Validators.required]);
  errorMessage: string = '';
  constructor(
    private authService: AuthService, apiService: ApiService
  ) {
    this.authService.loginError.subscribe(message => {
         this.errorMessage = message;
    });
  }

  formChange(): void {
    this.errorMessage = '';
  }

  login(): void {
      // Both fields must be set to continue
      if (!this.username.valid || !this.password.valid) {
        return;
      }
      const username = this.username.value;
      const password = this.password.value;
      if (!username ) {
        return;
      }
      if (!password) {
        return;
      }
      // Call aut service
      this.authService.login(username, password).subscribe(this.loginResult);
  }

  private loginResult(result: boolean) {
    if (!result) {
       console.log('Login failed');
       return;
    } else {
      console.log('Login success');
    }

  }


  getUserErrorMessage(): string {
    if (this.username.hasError('required')) {
      return 'You must enter a value';
    }
    return this.username.hasError('email') ? 'Not a valid email' : '';
  }

  ngOnInit(): void {

  }

}
